import { stringify } from 'query-string';
import type { CurrencyEnum } from '@spectrocoin/sc-currencies';
import Environment from './enums/Environment';

const URL = process.env.NODE_ENV === Environment.DEVELOPMENT ? 'http://spectrocoin.local:9999' : '';

export const getMerchantPreOrderUrl = (id: string) => `${URL}/api/fe/merchants/p/preorders/${id}`;
export const getMerchantPreOrderPaymentOptionsUrl = (id: string) =>
	`${URL}/api/fe/merchants/p/preorders/${id}/payment-options`;

export const createMerchantOrderUrl = () => `${URL}/api/fe/merchants/p/orders`;
export const createMerchantPreorderUrl = () => `${URL}/api/fe/merchants/p/preorders`;

export const getMerchantOrderUrl = (id: string) => `${URL}/api/fe/merchants/p/orders/${id}`;
export const getMerchantOrderStatusUrl = (id: string) =>
	`${URL}/api/fe/merchants/p/orders/${id}/status`;
export const getMerchantOrderInvoiceUrl = (id: string) =>
	`${URL}/api/fe/merchants/p/orders/${id}/invoice`;
export const getMerchantOrderCancelUrl = (id: string) =>
	`${URL}/api/fe/merchants/p/orders/${id}/cancel`;

export const getMerchantProjectURL = (id: string) => `${URL}/api/fe/merchants/p/projects/${id}`;
export const getMerchantCurrenciesURL = () => `${URL}/api/fe/merchants/p/currencies`;

export const getDonationButtonURL = (id: string) => `${URL}/api/fe/payment-buttons/p/${id}`;
export const getDonationButtonCurrenciesURL = (id: string) =>
	`${URL}/api/fe/payment-buttons/p/currencies?paymentButtonId=${id}`;
export const getDonationButtonCreateAddressURL = () => `${URL}/api/fe/payment-buttons/p/addresses`;
export const getDonationButtonAddressURL = (id: string) =>
	`${URL}/api/fe/payment-buttons/p/addresses/${id}`;
export const getLegacyDonationButtonURL = (id: string, key: string) =>
	`${URL}/api/fe/payment-buttons/p?${stringify({ id, key })}`;
export const getLegacyOrderURL = (id: string, key: string) =>
	`${URL}/api/fe/merchants/p/orders?${stringify({ id, key })}`;
export const getGiveCookieConsentURL = () => `${URL}/api/fe/consents/cookie`;
export const getCookieRevokeURL = () => `${URL}/consents/cookie/revoke`;
export const getCurrencyNetworkURL = (currencyCode?: CurrencyEnum, network?: string) =>
	`${URL}/api/fe/currency-network${currencyCode ? `?currencyCode=${currencyCode}` : ''}${
		network ? `&network=${network}` : ''
	}`;
